<div class="dc-modal">
  <div class="dc-modal-container bg-white min-w-4xs! max-w-[480px]!">
    <div class="text-center space-y-3 px-4 py-6">
      <h2 class="text-xl font-semibold text-dc-navy">
        <!--
         {{ "TOAST_MESSAGES.SUCCESS" | translate  }}</span> -->
           <span class="text-center"><img src="/icons/svg/info.svg" class="m-auto" /></span>
          {{ "TOAST_MESSAGES.MANGE_SIGNATORY_SR_PENDING" | translate }}
      </h2>
      <p class="p-5 text-dc-navy! font-semibold">
        {{ "TOAST_MESSAGES.REFERENCE_NO" | translate }} <span class="font-normal"> {{srNumber}}</span>
      </p>
    </div>
    <div class="flex gap-3 justify-center">      
      <app-button
        type="button"
        classesName="btn-edge-cut btn-width-auto"
        [label]="'BUTTONS.CLOSE' | translate"
        (onBtnClick)="continueSR()"
      ></app-button>
    </div>
  </div>
</div>